import { Tween, Easing } from '@tweenjs/tween.js';
import { Sprite, Texture, TextMetrics } from 'pixi.js';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import { formatCurrencyValue, getCurrencySymbol } from '../helper/currencies';
import { textManager } from '../../lib/lang/TextManager';

const events = [
	EVENTS.ALL_LINES_FINISHED,
	EVENTS.LINE_STARTED,
	EVENTS.AUTO_STARTED,
	EVENTS.BONUS_ROUND_STATE,
	EVENTS.SERVER_MSG,
	EVENTS.REEL_FINISHED,
	EVENTS.BONUS_BUY,
	EVENTS.NOTIFICATION
];

class WinInfoController {
	constructor(vc, conf) {
		this.t = textManager.getTranslationContext();
		this.vc = vc;
		this.config = conf;
		this.resetTimeoutId = null;
		this.imginit = false;
		this.retriggeredbonusspins = 0;
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.holder = new Sprite();
		this.vc.COPY.addChild(this.holder);
		this.state = 'welcome';
		this.win = 0;

		if (this.vc[this.config.item]) {
			this.item = this.vc[this.config.item];
			this.holder.addChild(this.item.label);
			this.holder.addChild(this.item.itemimg);
			this.holder.addChild(this.item.count);
			//INITIAL POSITION
			this.holder.anchor.x = 0.5;
			this.item.label.anchor.x = 0.5;
			this.item.count.anchor.x = 0.5;
			this.item.label.text = this.t('common.good_luck');
			const textMetrics = TextMetrics.measureText(
				this.item.label.text,
				this.item.label.style
			);
			this.item.label.position.x = textMetrics.width / 2 - 70;

			this.positionsStartSet();
		} else {
			throw new Error(
				'WinInfoController failed init ' + JSON.stringify(this.config)
			);
		}
		if (isDesktop) {
			window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
			window.addEventListener(EVENTS.DOUBLE_CHANCE, this, false);
		}
		events.forEach((event) => window.addEventListener(event, this, false));
	}

	resize(w, h) {
		const textMetrics = TextMetrics.measureText(
			this.item.label.text,
			this.item.label.style
		);
		const textMetricsCount = TextMetrics.measureText(
			this.item.count.text,
			this.item.count.style
		);
		if (!isDesktop) {
			if (w < h) {
				switch (this.state) {
					case 'welcome':
					case 'auto':
						this.item.label.position.x = textMetrics.width / 2 - 70;
						this.item.label.position.y = 0;
						break;
					case 'bonus':
						this.item.label.position.x = textMetrics.width / 2 - 45;
						this.item.label.position.y = 0;
						break;
					case 'bonusCompleted':
						this.item.label.position.x = textMetrics.width / 2 - 80;
						this.item.label.position.y = 0;
						break;
					case 'autoBets':
					case 'bonusBets':
						this.item.label.position.x = textMetrics.width / 2 - 65;
						this.item.count.position.x =
							this.item.label.position.x +
							textMetrics.width / 2 +
							textMetricsCount.width / 2 +
							5;
						this.item.label.position.y = 0;
						this.item.count.position.y = -3;
						break;
					case 'lines':
						if (textMetrics.width > 200) {
							this.item.label.position.x = textMetrics.width / 2 - 80;
							this.item.itemimg.position.x = -33;
						} else {
							this.item.label.position.x = textMetrics.width / 2 - 50;
							this.item.itemimg.position.x = -5;
						}

						this.item.label.position.y = 0;
						this.item.count.position.y = -3;
						if (this.item.itemimg) {
							this.item.itemimg.position.y = -10;
						}
						break;
					default:
						break;
				}
			} else {
				switch (this.state) {
					case 'welcome':
					case 'auto':
					case 'bonus':
					case 'bonusCompleted':
						this.item.label.position.x = 0;
						this.item.label.position.y = -40;
						break;
					case 'autoBets':
					case 'bonusBets':
						this.item.label.position.x = -textMetricsCount.width / 2;
						this.item.count.position.x =
							this.item.label.position.x +
							textMetrics.width / 2 +
							textMetricsCount.width / 2 +
							5;
						this.item.label.position.y = -37;
						this.item.count.position.y = -40;
						break;
					case 'lines':
						this.item.label.position.x = 0;
						this.item.label.position.y = -40;
						if (this.item.itemimg) {
							this.item.itemimg.position.x = -textMetrics.width / 2 + 45;
							this.item.itemimg.position.y = -50;
						}
						break;
					default:
						break;
				}
			}
		}
	}

	handleEvent(event) {
		switch (event.type) {
			case EVENTS.ALL_LINES_FINISHED:
				if (GameConfigs.autospin.isAutoOn && !GameConfigs.bonusBuy) {
					this.removeItemImg();
					if (GameConfigs.autospin.numOfBets !== '') {
						const betsLeft =
							GameConfigs.autospin.numOfBets - GameConfigs.autospin.leftBets;
						this.autoSpinsLeft(betsLeft);
					} else this.autoSpinActivatedText();
				} else if (this.retriggeredbonusspins) {
					this.freeSpinsLeft(this.retriggeredbonusspins);
					this.retriggeredbonusspins = 0;
				}
				break;
			case EVENTS.LINE_STARTED:
				this.lineStarted(event);
				break;
			case EVENTS.DOUBLE_CHANCE:
				this.state = 'settings';
				this.removeItemImg();
				this.item.label.text = this.t('common.double_chance');
				this.item.count.text = event.detail.doubleChance
					? this.t('common.turned_on')
					: this.t('common.turned_off');
				this.item.label.anchor.x = 1;
				this.item.count.anchor.x = 0;
				this.item.label.position.x = 0;
				this.item.count.position.x = 10;
				this.resetLabelTextWithDelay();
				break;
			case EVENTS.AUTO_STARTED:
				this.autoplay(event);
				break;
			case EVENTS.BONUS_ROUND_STATE:
				this.bonusState = event.detail.state;
				this.bonusFinished(event);
				break;
			case EVENTS.SETTINGS_UPDATE:
				this.settingsUpdate(event);
				break;
			case EVENTS.SERVER_MSG:
				this.serverMSG(event);
				break;
			case EVENTS.REEL_FINISHED:
				GameConfigs.bonusBuy && this.bonusState === 'init' && this.bonusText();
				break;
			case EVENTS.BONUS_BUY:
				GameConfigs.bonusBuy && this.goodLuckText();
				break;
			case EVENTS.NOTIFICATION:
				event.detail.notification && this.goodLuckText();
				break;
			default:
				break;
		}
	}
	settingsUpdate(e) {
		this.state = 'settings';
		if (Object.keys(e.detail.data)[0] === 'current_bet') return;
		this.removeItemImg();
		switch (Object.keys(e.detail.data)[0]) {
			case 'fast_spin':
				this.item.label.text = this.t('autoSpin.fast_spin');
				break;
			case 'background_music':
				this.item.label.text = this.t('settings.background_music');
				break;
			case 'game_animation':
				this.item.label.text = this.t('settings.animations');
				break;
			case 'keyboard_shortcuts':
				this.item.label.text = this.t('settings.shortcuts');
				break;
			case 'sound_effects':
				this.item.label.text = this.t('settings.sound');
				break;
			case 'splash_screen':
				this.item.label.text = this.t('settings.splash_screen');
				break;
			default:
				break;
		}
		this.item.count.text = Object.values(e.detail.data)[0]
			? this.t('common.turned_on')
			: this.t('common.turned_off');

		this.item.label.anchor.x = 1;
		this.item.count.anchor.x = 0;

		const textMetrics = TextMetrics.measureText(
			this.item.label.text,
			this.item.label.style
		);
		this.item.label.position.x = textMetrics.width / 2 - 70;
		this.item.count.position.x = textMetrics.width / 2 - 60;
		this.resetLabelTextWithDelay();
	}

	bonusFinished(e) {
		if (e.detail.state === '') {
			this.goodLuckText();
		}
		if (e.detail.state === 'init') {
			this.bonusText();
		}
		if (e.detail.state === 'started') {
			this.goodLuckText();
		}
		if (e.detail.state === 'finished') {
			this.roundCompletedText();
		}
	}

	autoplay(e) {
		this.positionsStartSet();
		if (e.detail.isAutoOn && !GameConfigs.bonusBuy) {
			this.removeItemImg();
			this.imginit = false;
			if (e.detail.numOfBets !== '') {
				this.autoSpinsLeft(GameConfigs.autospin.numOfBets);
			} else this.autoSpinActivatedText();
		} else {
			GameConfigs.bonusBuy ? this.bonusText() : this.goodLuckText();
		}
	}

	serverMSG(e) {
		if (
			e.detail.service === 'bet' &&
			!GameConfigs.autospin.isAutoOn &&
			!GameConfigs.bonusBuy
		) {
			this.goodLuckText();
		}
		if (e.detail.service === 'bonusstep') {
			this.positionsStartSet();
			this.removeItemImg();
			this.imginit = false;
			if (e.detail.data.totalbonusspins - e.detail.data.playedbonusspins >= 0) {
				const betsLeft =
					e.detail.data.totalbonusspins - e.detail.data.playedbonusspins;
				this.freeSpinsLeft(betsLeft);
				if (e.detail.data.retriggeredbonusspins) {
					const betsLeft =
						e.detail.data.totalbonusspins - e.detail.data.playedbonusspins;
					this.retriggeredbonusspins = betsLeft;
					this.freeSpinsLeft(betsLeft - e.detail.data.retriggeredbonusspins);
				}
			}
		}
		if (e.detail.service === 'bet' && GameConfigs.autospin.isAutoOn) {
			if (GameConfigs.autospin.numOfBets !== '') {
				this.positionsStartSet();
				const betsLeft =
					GameConfigs.autospin.numOfBets - GameConfigs.autospin.leftBets;
				this.autoSpinsLeft(betsLeft);
			} else {
				this.autoSpinActivatedText();
			}
		}
	}

	setValue(amount, count) {
		let str = '            ';
		this.item.label.text =
			count +
			'X' +
			str +
			this.t('common.pays') +
			' ' +
			formatCurrencyValue(amount, this.currency);
	}

	lineStarted(e) {
		this.state = 'lines';
		this.anim(1);
		this.removeItemImg();
		this.item.itemimg = new Sprite(
			Texture.from(this.config.items[e.detail.itemid].item)
		);
		this.imginit = true;
		this.item.itemimg.alpha = 1;
		if (this.config.items[e.detail.itemid].type === 'major') {
			this.item.itemimg.scale.set(1);
		} else {
			this.item.itemimg.scale.set(0.2);
			if (isMobile || isTablet) {
				this.item.itemimg.scale.set(0.4);
			}
		}

		this.item.count.text = '';
		this.item.addComponent(this.item.itemimg, this.item.itemimg);
		this.setValue(e.detail.amount, e.detail.itemcount);
		const textMetrics = TextMetrics.measureText(
			this.item.label.text,
			this.item.label.style
		);
		this.item.label.anchor.x = 0.5;
		this.item.itemimg.anchor.x = 0.5;
		if (isDesktop) {
			this.item.label.position.x = -50;
			this.item.itemimg.position.x = -5 - textMetrics.width / 2;
			this.item.itemimg.position.y = -10;
		} else {
			if (window.innerWidth < window.innerHeight) {
				this.item.itemimg.position.y = -10;
				if (textMetrics.width > 200) {
					this.item.label.position.x = textMetrics.width / 2 - 80;
					this.item.itemimg.position.x = -33;
				} else {
					this.item.label.position.x = textMetrics.width / 2 - 50;
					this.item.itemimg.position.x = -5;
				}
			} else {
				this.item.label.position.x = 0;
				this.item.itemimg.position.x = -textMetrics.width / 2 + 45;
				this.item.label.position.y = -40;
				if (this.item.itemimg) {
					this.item.itemimg.position.y = -50;
				}
			}
		}
	}

	positionsStartSet() {
		this.item.label.anchor.x = 0.5;
		this.item.count.anchor.x = 0.5;
		if (isDesktop) {
			this.item.label.position.x = -50;
		}
	}

	goodLuckText() {
		this.state = 'welcome';
		this.removeItemImg();
		this.item.label.text = this.t('common.good_luck');
		this.positionsStartSet();
		this.item.count.text = '';
	}
	bonusText() {
		this.state = 'bonus';
		this.removeItemImg();
		this.item.label.text = this.t('bonus.bonus_triggered');
		this.item.count.text = '';
		const textMetrics = TextMetrics.measureText(
			this.item.label.text,
			this.item.label.style
		);
		this.item.label.anchor.x = 0.5;
		this.item.count.anchor.x = 0.5;
		if (isDesktop) {
			this.item.label.position.x = -50;
		} else {
			if (window.innerWidth < window.innerHeight) {
				this.item.label.position.x = textMetrics.width / 2 - 45;
				this.item.label.position.y = 0;
			} else {
				this.item.label.position.x = 0;
				this.item.label.position.y = -40;
			}
		}
	}

	autoSpinActivatedText() {
		this.state = 'auto';
		this.removeItemImg();
		this.item.label.anchor.x = 0.5;
		this.item.count.anchor.x = 0.5;
		this.item.label.text = this.t('common.autoSpinActivated');
		this.item.count.text = '';
	}
	autoSpinsLeft(betsLeft) {
		this.state = 'autoBets';
		this.removeItemImg();
		this.item.label.anchor.x = 0.5;
		this.item.count.anchor.x = 0.5;
		this.item.label.text = this.t('common.autoSpinLeft');
		this.item.count.text = betsLeft;
		const textMetrics = TextMetrics.measureText(
			this.item.label.text,
			this.item.label.style
		);
		const textMetricsCount = TextMetrics.measureText(
			this.item.count.text,
			this.item.count.style
		);
		if (isDesktop) {
			this.item.label.position.x = -70;
			this.item.count.position.x = textMetricsCount.width / 2 + 10;
		} else {
			if (window.innerWidth < window.innerHeight) {
				this.item.label.position.x = textMetrics.width / 2 - 65;
				this.item.count.position.x =
					this.item.label.position.x +
					textMetrics.width / 2 +
					textMetricsCount.width / 2 +
					5;
				this.item.label.position.y = 0;
				this.item.count.position.y = -3;
			} else {
				this.item.label.position.x = -textMetricsCount.width / 2;
				this.item.count.position.x =
					this.item.label.position.x +
					textMetrics.width / 2 +
					textMetricsCount.width / 2 +
					5;
				this.item.label.position.y = -37;
				this.item.count.position.y = -40;
			}
		}
	}

	freeSpinsLeft(betsLeft) {
		this.state = 'bonusBets';
		this.removeItemImg();
		this.item.label.text = this.t('bonus.bonus_spins_left');
		this.item.count.text = betsLeft;
		this.item.label.anchor.x = 0.5;
		this.item.count.anchor.x = 0.5;
		const textMetrics = TextMetrics.measureText(
			this.item.label.text,
			this.item.label.style
		);
		const textMetricsCount = TextMetrics.measureText(
			this.item.count.text,
			this.item.count.style
		);
		if (isDesktop) {
			this.item.label.position.x = -70;
			this.item.count.position.x = textMetricsCount.width / 2 + 15;
		} else {
			if (window.innerWidth < window.innerHeight) {
				this.item.label.position.x = textMetrics.width / 2 - 65;
				this.item.count.position.x =
					this.item.label.position.x +
					textMetrics.width / 2 +
					textMetricsCount.width / 2 +
					5;
				this.item.label.position.y = 0;
				this.item.count.position.y = -3;
			} else {
				this.item.label.position.x = -textMetricsCount.width / 2;
				this.item.count.position.x =
					this.item.label.position.x +
					textMetrics.width / 2 +
					textMetricsCount.width / 2 +
					5;
				this.item.label.position.y = -37;
				this.item.count.position.y = -40;
			}
		}
	}
	roundCompletedText() {
		this.state = 'bonusComplete';
		this.removeItemImg();
		this.item.label.text = this.t('common.bonusRoundCompleted');
		this.item.count.text = '';
		this.item.label.anchor.x = 0.5;
		this.item.count.anchor.x = 0.5;
		if (isDesktop) {
			this.item.label.position.x = -50;
		}
	}
	removeItemImg() {
		if (this.imginit && this.item.itemimg) {
			this.item.label.text = '';
			this.item.itemimg.parent.removeChild(this.item.itemimg);
			delete this.item.itemimg;
		}
	}

	resetLabelTextWithDelay() {
		if (this.resetTimeoutId) {
			clearTimeout(this.resetTimeoutId);
		}
		const timeoutDuration = 3000;
		this.resetTimeoutId = setTimeout(() => {
			this.goodLuckText();
		}, timeoutDuration);
	}

	anim(alpha) {
		this.tweener = new Tween(this.item)
			.to({ alpha: alpha }, 300)
			.easing(Easing.Linear.None)
			.start();
	}
	animateText(text) {
		this.tweener = new Tween(text)
			.to({ alpha: 0 }, 100)
			.yoyo(true)
			.repeat(3)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				new Tween(text).to({ alpha: 0 }, 100).start();
			})
			.start();
	}
}

export default WinInfoController;
